// src/components/Header.jsx - MOBİL UYUMLU + SCROLL DAVRANIŞI + ADMIN KONTROLÜ
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Search, User, Heart, ShoppingCart, Phone, Mail,
  ShoppingBag, Star, MessageSquare, Settings, LogOut, ChevronDown,
  Shield // ✅ YENİ: Admin ikonu
} from 'lucide-react';
import CategoryMegaMenu from './CategoryMegaMenu';
import toast from 'react-hot-toast';
import pnglogo from '../assets/tronalogo.png';
import './Header.css';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';

export default function Header({
  wishlistCount,
  cartCount,
  searchQuery,
  setSearchQuery,
  onSearch,
  onCartClick,
  onWishlistClick,
  onCampaignsClick,
  availableCategories = [],
  products = []
}) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [showAccountMenu, setShowAccountMenu] = useState(false);
  const [showCategoryMenu, setShowCategoryMenu] = useState(false);

  // ✨ Scroll yönü ve kompakt mod
  const [scrollDirection, setScrollDirection] = useState('up');
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isCompact, setIsCompact] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const accountMenuRef = useRef(null);
  const categoryMenuRef = useRef(null);
  const categoryCloseTimerRef = useRef(null);
  const accountCloseTimerRef = useRef(null);

  const isLoggedIn = localStorage.getItem('userToken') || localStorage.getItem('isLoggedIn');
  const userName = localStorage.getItem('userName') || 'Kullanıcı';
  const userEmail = localStorage.getItem('userEmail') || ''; // ✅ YENİ

  // ✅ YENİ: Admin mailler listesi
  const ADMIN_EMAILS = [
    'info@tronapazarlama.com'
  ];

  // ✅ YENİ: Mail kontrolü ile admin kontrolü
  const isAdmin = ADMIN_EMAILS.includes(userEmail.toLowerCase());

  console.log('🔐 Header - User Email:', userEmail, 'Is Admin:', isAdmin);

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  // ✨ Scroll davranışı - SADECE MOBİLDE header küçülür
  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const currentScrollY = window.scrollY;

          // ✅ Sadece mobilde (768px ve altı) kompakt mod aktif olsun
          const isMobile = window.innerWidth <= 768;

          // ✅ Sayfa sonunda kompakt mod kontrolünü durdur
          const isNearBottom = (window.innerHeight + window.scrollY) >= (document.documentElement.scrollHeight - 100);

          if (isMobile && !isNearBottom) {
            // Scroll yönünü belirle - minimum 80px scroll gerekli
            if (currentScrollY > lastScrollY && currentScrollY > 80) {
              // Aşağı scroll - Compact mode aktif
              setScrollDirection('down');
              setIsCompact(true);
            } else if (currentScrollY < lastScrollY - 10) {
              // Yukarı scroll - Normal mode (10px threshold ile daha stabil)
              setScrollDirection('up');
              setIsCompact(false);
            }
          } else {
            // Desktop'ta veya sayfa sonunda kompakt mod her zaman kapalı
            setIsCompact(false);
          }

          setIsScrolled(currentScrollY > 20);
          setLastScrollY(currentScrollY);
          ticking = false;
        });

        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    // ✅ Resize olayını da dinle (desktop'a geçişte kompakt modu kapat)
    const handleResize = () => {
      const isMobile = window.innerWidth <= 768;
      if (!isMobile) {
        setIsCompact(false);
      }
    };

    window.addEventListener('resize', handleResize, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, [lastScrollY]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (accountMenuRef.current && !accountMenuRef.current.contains(event.target)) {
        setShowAccountMenu(false);
      }
      if (categoryMenuRef.current && !categoryMenuRef.current.contains(event.target)) {
        handleCategoryMouseLeave();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    return () => {
      if (categoryCloseTimerRef.current) {
        clearTimeout(categoryCloseTimerRef.current);
      }
      if (accountCloseTimerRef.current) {
        clearTimeout(accountCloseTimerRef.current);
      }
    };
  }, []);

  const handleLogout = async () => {
    try {
      console.log('════════════════════════════════');
      console.log('🚪 NAVBAR ÇIKIŞ YAPILIYOR...');
      console.log('📧 Mevcut kullanıcı:', auth.currentUser?.email);
      console.log('════════════════════════════════');

      // 1. Firebase Auth'dan çıkış (EN ÖNEMLİSİ!)
      await signOut(auth);

      console.log('✅ Firebase signOut tamamlandı');
      console.log('📧 Auth durumu:', auth.currentUser); // null olmalı

      // 2. SessionStorage temizle (visitor tracking için kritik!)
      sessionStorage.clear();
      console.log('✅ SessionStorage temizlendi');

      // 3. localStorage'dan sadece auth bilgilerini temizle
      localStorage.removeItem('userToken');
      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('userName');
      localStorage.removeItem('userEmail');
      localStorage.removeItem('userId');
      localStorage.removeItem('user');

      console.log('✅ Auth verileri temizlendi');

      toast.success('Çıkış yapıldı');
      setShowAccountMenu(false);

      // 4. Sayfayı yenile (mecburi!)
      console.log('🔄 Sayfa yenileniyor...');
      setTimeout(() => {
        window.location.href = '/';
      }, 300);

    } catch (error) {
      console.error('❌ ÇIKIŞ HATASI:', error);
      toast.error('Çıkış yapılırken hata oluştu');

      // Hata olsa bile force temizlik
      sessionStorage.clear();
      localStorage.removeItem('userToken');
      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('userName');
      localStorage.removeItem('userEmail');
      localStorage.removeItem('userId');
      localStorage.removeItem('user');

      window.location.href = '/';
    }
  };

  const handleAccountClick = () => {
    if (!isLoggedIn) {
      navigate('/account');
    }
  };

  const handleAccountMouseEnter = () => {
    if (accountCloseTimerRef.current) {
      clearTimeout(accountCloseTimerRef.current);
      accountCloseTimerRef.current = null;
    }
    if (isLoggedIn) {
      setShowAccountMenu(true);
    }
  };

  const handleAccountMouseLeave = () => {
    accountCloseTimerRef.current = setTimeout(() => {
      setShowAccountMenu(false);
    }, 300);
  };

  const handleCategoryMouseEnter = () => {
    if (categoryCloseTimerRef.current) {
      clearTimeout(categoryCloseTimerRef.current);
      categoryCloseTimerRef.current = null;
    }

    if (availableCategories.length > 0) {
      setShowCategoryMenu(true);
    }
  };

  const handleCategoryMouseLeave = () => {
    categoryCloseTimerRef.current = setTimeout(() => {
      setShowCategoryMenu(false);
    }, 300);
  };

  return (
    <header className={`header ${isScrolled ? 'header-scrolled' : ''} ${isCompact ? 'header-compact' : ''}`}>

      {/* Header Main - Mobilde scroll'da gizlenir */}
      <div className="header-main">
        <div className="header-container">
          <div className="header-main-content">
            <div className="header-logo" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
              <img src={pnglogo} alt="Trona" />
            </div>

            <form className="header-search-bar" onSubmit={onSearch}>
              <Search className="header-search-icon" size={20} />
              <input
                type="text"
                placeholder="Ürün, marka veya kategori ara..."
                className="header-search-input"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <button type="submit" className="header-search-btn">Ara</button>
            </form>

            <div className="header-actions">
              {/* Account Dropdown */}
              <div
                className="header-account-dropdown-wrapper"
                ref={accountMenuRef}
                onMouseEnter={handleAccountMouseEnter}
                onMouseLeave={handleAccountMouseLeave}
              >
                <button className="header-icon-btn" onClick={handleAccountClick}>
                  <User size={20} />
                  <span>Hesabım</span>
                </button>

                {isLoggedIn && showAccountMenu && (
                  <div className="header-account-dropdown-menu">
                    <div className="header-account-menu-header">
                      <User size={18} />
                      <span className="header-account-menu-user">{userName}</span>
                    </div>
                    <div className="header-account-menu-divider"></div>

                    {/* ✅ YENİ: SADECE ADMIN İÇİN ADMIN PANEL BUTONU */}
                    {isAdmin && (
                      <>
                        <button
                          className="header-account-menu-item header-admin-panel"
                          onClick={() => {
                            navigate('/admin');
                            setShowAccountMenu(false);
                          }}
                        >
                          <Shield size={18} />
                          <span>Admin Panel</span>
                        </button>
                        <div className="header-account-menu-divider"></div>
                      </>
                    )}

                    <button
                      className="header-account-menu-item"
                      onClick={() => {
                        navigate('/orders');
                        setShowAccountMenu(false);
                      }}
                    >
                      <ShoppingBag size={18} />
                      <span>Siparişlerim</span>
                    </button>
                    <button
                      className="header-account-menu-item"
                      onClick={() => {
                        navigate('/reviews');
                        setShowAccountMenu(false);
                      }}
                    >
                      <Star size={18} />
                      <span>Değerlendirmelerim</span>
                    </button>
                    <button
                      className="header-account-menu-item"
                      onClick={() => {
                        navigate('/account/settings');
                        setShowAccountMenu(false);
                      }}
                    >
                      <Settings size={18} />
                      <span>Hesap Ayarları</span>
                    </button>
                    <div className="header-account-menu-divider"></div>
                    <button
                      className="header-account-menu-item header-logout"
                      onClick={handleLogout}
                    >
                      <LogOut size={18} />
                      <span>Çıkış Yap</span>
                    </button>
                  </div>
                )}
              </div>

              <button className="header-icon-btn" onClick={onWishlistClick}>
                <Heart size={20} />
                <span>Favoriler</span>
                {wishlistCount > 0 && <span className="header-badge">{wishlistCount}</span>}
              </button>

              <button className="header-cart-btn" onClick={onCartClick}>
                <ShoppingCart size={20} />
                <span>Sepetim</span>
                <span className="header-badge">{cartCount}</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Header Nav - Her zaman görünür */}
      <div className="header-nav">
        <div className="header-container">
          <nav className="header-nav-links">
            {/* ✨ Mobilde logo küçültülmüş hali */}
            <div className="header-mobile-compact-logo" onClick={() => navigate('/')}>
              <img src={pnglogo} alt="Trona" />
            </div>

            {/* ✨ Kompakt modda küçük searchbar */}
            <form className="header-compact-search-bar" onSubmit={onSearch}>
              <Search className="header-search-icon" size={16} />
              <input
                type="text"
                placeholder="Ara..."
                className="header-search-input"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </form>


            <a href="/"
              className={`header-nav-link ${isActive('/') ? 'header-nav-link-active' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                navigate('/');
              }}
            >
              Anasayfa
            </a>

            <a href="/campaigns"
              className={`header-nav-link ${isActive('/campaigns') ? 'header-nav-link-active' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                onCampaignsClick();
              }}
            >
              Kampanyalar
            </a>

            {/* KATEGORİLER DROPDOWN */}
            <div
              className="header-nav-dropdown-wrapper"
              ref={categoryMenuRef}
              onMouseEnter={handleCategoryMouseEnter}
              onMouseLeave={handleCategoryMouseLeave}
            >

              <a href=""
                className="header-nav-link-with-icon"
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/search');
                }}
              >
                Kategoriler
                <ChevronDown size={16} className={`header-dropdown-icon ${showCategoryMenu ? 'header-dropdown-icon-open' : ''}`} />
              </a>

              {showCategoryMenu && (
                <CategoryMegaMenu
                  availableCategories={availableCategories}
                  products={products}
                  onClose={() => setShowCategoryMenu(false)}
                  triggerRef={categoryMenuRef}
                  onMouseEnter={handleCategoryMouseEnter}
                  onMouseLeave={handleCategoryMouseLeave}
                />
              )}
            </div>


            <a href=""
              className={`header-nav-link ${isActive('/reviews') ? 'header-nav-link-active' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                navigate('/reviews');
              }}
            >
              Değerlendirmeler
            </a>

            <a href="#"
              className="header-nav-link"
              onClick={(e) => {
                e.preventDefault();
                navigate(`/search?filter`);
              }}
            >
              Ürünler
            </a>

            <a href=''
              className={`header-nav-link ${isActive('/order-tracking') ? 'header-nav-link-active' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                navigate('/order-tracking');
              }}
            >
              Sipariş Takibi
            </a>

            <a href=""
              className={`header-nav-link ${isActive('/contact') ? 'header-nav-link-active' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                navigate('/contact');
              }}
            >
              İletişim
            </a>

            <a href=""
              className={`header-nav-link ${isActive('/about') ? 'header-nav-link-active' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                navigate('/about');
              }}
            >
              Hakkımızda
            </a>

            {/* ✨ Mobil kompakt modda sağ butonlar */}
            <div className="header-mobile-compact-actions">
              <button className="header-compact-icon-btn" onClick={onWishlistClick}>
                <Heart size={18} />
                {wishlistCount > 0 && <span className="header-compact-badge">{wishlistCount}</span>}
              </button>
              <button className="header-compact-icon-btn header-compact-cart" onClick={onCartClick}>
                <ShoppingCart size={18} />
                <span className="header-compact-badge">{cartCount}</span>
              </button>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
}